export function CamelCaseToSplitPascal(word: string) {
  const output: string[] = [];
  let i: number;
  let l: number;
  const capRe = /[A-Z]/;
  if (typeof (word) !== 'string') {
    throw new Error('The "word" parameter must be a string.');
  }
  for (i = 0, l = word.length; i < l; i += 1) {
    if (i === 0) {
      output.push(word[i].toUpperCase());
    } else {
      if (i > 0 && capRe.test(word[i])) {
        output.push(' ');
      }
      output.push(word[i]);
    }
  }
  return output.join('');
}

export function SplitPascalCase(text: string) {
  const wordRe = /($[a-z])|[A-Z][^A-Z]+/g;
  const result = text.match(wordRe)?.join(' ');
  return !result || result === ' ' ? text : result;
}
